import { useState } from 'react'

const testimonials = [
  {
    id: 1,
    name: 'keval Sharma',
    city: 'pune',
    state: 'Maharashtra',
    content:
      "Orbix Globle Inc has transformed our supply chain operations. Their expertise in customs clearance and freight forwarding has reduced our shipping costs by 25% while improving delivery times. Outstanding service!",
    avatar: '👩‍💼',
  },
  {
    id: 2,
    name: 'Rajesh Kumar',
    city: 'chapra',
    state: 'Bihar',
    content:
      'Working with Orbix Globle Inc for over 3 years has been exceptional. Their air freight services are reliable, and their customer support team is always available to handle urgent shipments. Highly recommended for international trade.',
    avatar: '👨',
  },
  {
    id: 3,
    name: 'surendar Patel',
    city: 'gandhinagar',
    state: 'Gujarat',
    content:
      'The warehousing and distribution services provided by Orbix Globle Inc have streamlined our inventory management. Their technology platform gives us real-time visibility, and their team is incredibly professional.',
    avatar: '👩‍💼',
  },
]

const partners = [
  { name: 'DHL', logo: 'DHL' },
  { name: 'FedEx', logo: 'FedEx' },
  { name: 'Maersk', logo: 'Maersk' },
  { name: 'UPS', logo: 'UPS' },
  { name: 'CMA CGM', logo: 'CMA CGM' },
  { name: 'MSC', logo: 'MSC' },
]

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <section className="py-16 bg-neutral">
      <div className="section-container">
        {/* Testimonials */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="section-title">What Our Clients Say</h2>
            <p className="section-subtitle mx-auto">
              Trusted by businesses worldwide for reliable logistics solutions
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="card">
              <div className="text-center mb-6">
                <div className="text-6xl mb-4">{testimonials[activeIndex].avatar}</div>
                <blockquote className="text-lg md:text-xl text-neutral-700 mb-6 italic">
                  "{testimonials[activeIndex].content}"
                </blockquote>
                <div>
                  <div className="font-display font-bold text-primary">
                    {testimonials[activeIndex].name}
                  </div>
                  <div className="text-sm text-neutral-600">
                    {testimonials[activeIndex].city}, {testimonials[activeIndex].state}
                  </div>
                </div>
              </div>

              {/* Navigation Dots */}
              <div className="flex justify-center space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveIndex(index)}
                    className={`w-3 h-3 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-primary ${
                      index === activeIndex
                        ? 'bg-primary w-8'
                        : 'bg-neutral-300 hover:bg-neutral-400'
                    }`}
                    aria-label={`View testimonial ${index + 1}`}
                    aria-pressed={index === activeIndex}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Partner Companies */}
        {/* <div>
          <div className="text-center mb-8">
            <h3 className="text-2xl font-display font-bold text-primary mb-2">
              Trusted Global Partners
            </h3>
            <p className="text-neutral-600">
              Partnered with leading logistics and shipping companies worldwide
            </p>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
            {partners.map((partner) => (
              <div
                key={partner.name}
                className="px-6 py-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="text-2xl font-display font-bold text-primary">
                  {partner.logo}
                </div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  )
}

